// extracted by mini-css-extract-plugin
module.exports = {"root":"app-chip-area-input_root__Z3l0q","paper":"app-chip-area-input_paper__1C8J9","chipWrap":"app-chip-area-input_chipWrap__LqLJ5"};